import { render, staticRenderFns } from "./AddDocumentCurrency.vue?vue&type=template&id=2c431b0c&"
import script from "./AddDocumentCurrency.vue?vue&type=script&lang=js&"
export * from "./AddDocumentCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports